import {Box, Container} from "@mui/material";

export const TermsPage = () => {
  return (
    <Container>
      <header>
        <h1>Terms of Use</h1>
        <p>Effective Date: 2024/2025</p>
      </header>

      <section>
        <h2>Overview</h2>
        <p>This website is part of an academic and scientific experiment aimed at advancing research in the field. By
          using
          this service, you contribute to the development of knowledge and help the research community.</p>
      </section>

      <section>
        <h2>Data Usage</h2>
        <p>All data collected through this website will be anonymized and may be shared with the academic and
          scientific
          community for research purposes. We ensure that no personally identifiable information will be associated
          with
          your contributions.</p>
      </section>

      <section>
        <h2>User Consent</h2>
        <p>By using this website, you agree to participate in this research initiative and allow your data to be used
          in
          accordance with the terms outlined here.</p>
      </section>

      <section>
        <h2>Disclaimer</h2>
        <p>This service is provided "as is" without any guarantees or warranties. As it is part of an experimental
          research
          project, its availability and functionality may be subject to change without prior notice.</p>
      </section>

      <footer>
        <p>&copy; 2024 Academic Research Project. All Rights Reserved.</p>
      </footer>
    </Container>

  )
}